import {
  ResponseType,
  PaginationResponseType,
  PageRequest,
  FilterLibraryType,
  FilterLibraryCriteria,
  ParamData,
} from '@types';
import { axios, get, post, put } from './baseAxios';
import { API_FILTER_LIBRARY } from './urls';

const url = API_FILTER_LIBRARY;

const create = (request: FilterLibraryType): Promise<ResponseType<FilterLibraryType>> =>
  post(`${url}`, request);

const update = (id: number, request: FilterLibraryType): Promise<ResponseType<FilterLibraryType>> =>
  put(`${url}/${id}`, request);

const deleteById = (id: number): Promise<ResponseType<boolean>> => axios.delete(`${url}/${id}`);

const getById = (id: number): Promise<ResponseType<FilterLibraryType>> => get(`${url}/${id}`);

const filter = (
  request: PageRequest & FilterLibraryCriteria
): Promise<PaginationResponseType<FilterLibraryType[]>> =>
  get(`${url}`, { params: { ...request } });

const getParams = (): Promise<ResponseType<ParamData[]>> => get(`${url}/params`);

const publish = (request: FilterLibraryType): Promise<ResponseType<FilterLibraryType>> =>
  put(`${url}/${request.id}/published`, request);

export { create, update, deleteById, getById, filter, getParams, publish };
